export default __webpack_public_path__ + "static/doina-0cf8cbe0f031b817b78b7ec9497b20d9.png";